import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from '@/components/ui/select';
import type { IndexCategory } from '@services/livability/types';

const INDEX_CATEGORIES: { value: IndexCategory; label: string }[] = [
  { value: 'general', label: 'Všeobecné' },
  { value: 'budget', label: 'Rozpočtové' },
  { value: 'family', label: 'Rodinné' },
  { value: 'student', label: 'Študentské' }
]

interface IndexCategorySelectProps {
  value: IndexCategory
  onChange: (value: IndexCategory) => void
  className?: string
  /** Hide the inline "Hodnotenie:" prefix (e.g. when an external label exists). */
  hidePrefix?: boolean
}

export function IndexCategorySelect({
  value,
  onChange,
  className,
  hidePrefix = false
}: IndexCategorySelectProps) {
  const activeLabel =
    INDEX_CATEGORIES.find((c) => c.value === value)?.label ?? 'Všeobecné'

  return (
    <Select value={value} onValueChange={(v) => onChange(v as IndexCategory)}>
      <SelectTrigger
        className={className}
        aria-label="Kategória hodnotenia"
      >
        <span className="flex items-center gap-1.5 truncate">
          {!hidePrefix && (
            <span className="shrink-0 text-muted-foreground font-normal">
              Hodnotenie:
            </span>
          )}
          <SelectValue>{activeLabel}</SelectValue>
        </span>
      </SelectTrigger>
      <SelectContent align="start">
        {INDEX_CATEGORIES.map(({ value: optionValue, label }) => (
          <SelectItem key={optionValue} value={optionValue}>
            {label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
